export var SKYC_FORM_TYPE = {
  MOBILE_NUMBER_VERIFICATION: 'MOBILE_NUMBER_VERIFICATION',
  AADHAAR_VERIFICATION: 'AADHAAR_VERIFICATION',
  AADHAAR_DETAILS: 'AADHAAR_DETAILS',
  PHOTO_VERIFICATION: 'PHOTO_VERIFICATION',
  VIDEO_VERIFICATION: 'VIDEO_VERIFICATION',
  SIM_DECLARATION: 'SIM_DECLARATION',
  DISABILITY_INFO: 'DISABILITY_INFO',
  LOCAL_REFERENCE_DETAILS: 'LOCAL_REFERENCE_DETAILS',
  IDENTITY_PROOF: 'IDENTITY_PROOF',
  CURRENT_ADDRESS_DETAILS: 'CURRENT_ADDRESS_DETAILS',
  INCOME_DETAILS_VERIFICATION: 'INCOME_DETAILS_VERIFICATION',
  SIM_PORT_DETAILS: 'SIM_PORT_DETAILS',
  NUMBER_SELECTION: 'NUMBER_SELECTION'
};